import { Segment, SegmentContent, SegmentHeader } from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import CommunicationCard from './components/CommunicationCard';
import CommunicationStoreForm from './components/CommunicationStoreForm';
import CommunicationUpdateForm from './components/CommunicationUpdateForm';
import EmployeeShowLayout from './layouts/EmployeeShowLayout';

const CommunicationView = () => {
    const { employee } = usePage().props;

    const communications = [...(employee?.communications ?? [])].sort(
        (a, b) => b.id - a.id
    );

    return (
        <>
            <CommunicationStoreForm />

            {communications.length === 0 ? (
                <Segment>
                    <SegmentHeader header='Communicatie' />
                    <SegmentContent>
                        <p className='text-sm text-gray-500'>
                            Deze werknemer heeft nog geen communicatie.
                        </p>
                    </SegmentContent>
                </Segment>
            ) : (
                <>
                    <CommunicationUpdateForm />

                    {communications.map(communication => (
                        <CommunicationCard
                            key={communication.id}
                            communication={communication}
                        />
                    ))}
                </>
            )}
        </>
    );
};

CommunicationView.layout = page => (
    <EmployeeShowLayout>{page}</EmployeeShowLayout>
);

export default CommunicationView;
